import { useDispatch, useSelector } from "react-redux";
import styled, { useTheme } from "styled-components";
import useLocalization from "../../../../../hooks/localization";
import { ArrowForward } from "@mui/icons-material";
import { setShowFeedbackForm } from "../../../../../redux/actions/formActions";
import { FEEDBACK_OPEN, FEEDBACK_SUB_EVENT } from "../../../../../constants/events";
import { logEventRecord } from "../../../../../redux/actions/chatActions";
import uuid from "react-uuid";

const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  padding: 0.5rem 0;
  justify-content: center;
  align-items: center;
`;

const InnerDiv = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 0.5rem;
  line-height: 1.3;
  font-size: ${({ theme }) => theme.sm};
  font-style: normal;
  text-decoration: none;
  font-weight: 600;
  color: #37393B;
  cursor: pointer;
  user-select: none;

  &:hover {
    text-decoration: underline;
  }
`;

function FeedbackSection() {
  const tooltips = useSelector(
    (state) => state?.org?.customizations?.tooltips?.footer
  );

  const theme = useTheme();
  const { localizeText } = useLocalization();
  const dispatch = useDispatch();
  
  const logFeedbackEvent = (type) => {
    dispatch(logEventRecord("", null, uuid(), type, FEEDBACK_SUB_EVENT, true, ""));
  };
  
  return (
    <Container>
      <InnerDiv 
        role="button"
        id="feedback-container"
        tabIndex={0}
        onClick={() => {
          dispatch(setShowFeedbackForm(FEEDBACK_OPEN));
          logFeedbackEvent(FEEDBACK_OPEN);
        }}
        onKeyDown={(e) =>{
          if(e.key === 'Enter' || e.key === ' '){
            e.preventDefault();
            dispatch(setShowFeedbackForm(FEEDBACK_OPEN));
            logFeedbackEvent(FEEDBACK_OPEN);
          }
        }}
      >
        <span>{localizeText(tooltips?.feedbackSection)}</span>
        <ArrowForward sx={{ fontSize: `${theme.md} !important` }}/>
      </InnerDiv>
    </Container>
  );
}

export default FeedbackSection;
